module.exports = {
	"accessRequestInvalid": "Cette demande d'accès est invalide. Vous pouvez en demander une à un administrateur de ce compte.",
	"accessRequestSuccess": "Vous avez maintenant accès au compte d'encanteur __name__.",
	"buyerPremium": "Prime de l'acheteur",
	"claim": {
		"request": "Je suis le propriétaire de cette entreprise. Réclamer cette fiche.",
		"claimListing": "Réclamer cette fiche",
		"confirmationMessage": "Si vous voulez réclamer cette fiche d'encanteur et modifier ses informations, nous devons vous envoyer un courriel pour confirmer que vous possédez l'adresse courriel que nous avons:",
		"send": "Envoyer un courriel de confirmation"
	},
	"created": "Organisation créée.",
	"manageAccountBtn": "Gérer le compte",
	"methodsOfPayment": "Mode de paiement accepté",
	"methodsOfPayment_plural": "Modes de paiement acceptés",
	"noMethodsOfPayment": "Aucuns n'ont été spécifiés par le vendeur.",
	"noRecentAuctions": "Aucun encan récent.",
	"noUpcomingAuctions": "Aucun encan à venir.",
	"organizations": "Organisations",
	"recentAuctions": "Encans récents",
	"listOrganizations": {
		"header": "Annuaire",
		"noOrganizations": "Aucun encanteur."
	},
	"subscription": {
		"basic": "Base",
		"premium": "Premium"
	},
	"createOrganization": {
		"header": "Créer un compte d'encanteur",
		"access": "Vous avez accès aux comptes d'encanteurs actifs suivants. Vous pouvez faire une requête d'accès à l'administrateur du compte ou <a>créer un compte</a> et commencer à vendre aujourd'hui.",
		"businessName": "Nom de l'entreprise",
		"createBtn": "Créer",
		"created": "Compte d'encanteur créé avec succès.",
		"descriptionPlaceholder": "Description de l'entreprise...",
		"emailPlaceholder": "contact@exemple.com",
		"friendlyId": "ID convivial",
		"friendlyidLabel": "URL convivial",
		"h2ContactInformation": "Coordonnées",
		"h2GeneralInformation": "Information générale",
		"namePlaceholder": "Nom de l'entreprise"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/organization.json5
// module id = 2000
// module chunks = 6